export type MenuItemsData = {
  step: number;
  name: string;
};

export const menuItems: MenuItemsData[] = [
  {
    step: 1,
    name: 'Local do abastecimento',
  },
  {
    step: 2,
    name: 'Nível do gás',
  },
  {
    step: 3,
    name: 'Agendamento',
  },
  {
    step: 4,
    name: 'Dados do responsável',
  },
  {
    step: 5,
    name: 'Conclusão',
  },
];

export const menuMobileItems: MenuItemsData[] = [
  {
    step: 1,
    name: 'Local do abastecimento',
  },
  {
    step: 2,
    name: 'Nível do gás',
  },
  {
    step: 3,
    name: 'Agendamento',
  },
  {
    step: 4,
    name: 'Dados do responsável',
  },
  {
    step: 5,
    name: 'Conclusão',
  },
];
